import { render } from "./CompTabs.vue?vue&type=template&id=8ca88588&scoped=true&ts=true"
import script from "./CompTabs.vue?vue&type=script&lang=ts"
export * from "./CompTabs.vue?vue&type=script&lang=ts"

import "./CompTabs.vue?vue&type=style&index=0&id=8ca88588&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca88588"]])

export default __exports__